import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const compassProductSettingsRoute: InvariantJiraRoute = {
	name: 'compass-product-settings',
	path: '/jira/settings/products/compass',
	exact: true,
};
